import { PayloadAction } from '@reduxjs/toolkit';

export const setLoading = (state: IAppState, action: PayloadAction<boolean>) => {
  state.isLoadingFullScreen = action.payload;
};
